import { IconCross } from '../../icons/IconCross';
import IconSearch from '../../icons/IconSearch';

interface SearchInputFilters {
  search: string;
}

export default function SearchInputFilter({
  filters,
  handleSearchChange,
  placeholder,
}: {
  filters: SearchInputFilters;
  handleSearchChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <>
      {/* Search Input */}
      <div className="flex flex-col gap-2 justify-between">
        <label htmlFor="search" className="block text-sm font-medium text-gray-700  dark:text-zinc-100 mb-1">
          Search Documents
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <IconSearch className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            id="search"
            value={filters.search}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder={placeholder ?? "Search by filename..."}
            className="block w-full pl-10 pr-8 py-2 border border-gray-300 dark:border-zinc-700 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 truncate"
          />
          {filters.search && (
            <button
              onClick={() => handleSearchChange('')}
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
            >
              <IconCross className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            </button>
          )}
        </div>
      </div>
    </>
  );
}
